require('./style.less');

var PageImageWr = require('../page'),
    $ = require('jquery'),
    CanvasBridgeMixin = require('../canvasMixin/canvasMixin');


module.exports = PageImageWr.extend({

    className: 'FV-pgWr FV-pgWr-PgMode',


    onAfterImageAppend: function() {

        this.createCanvas(); // now sync
        this._reveal();

    },

    // renders too
    createCanvas: function() {

        _.extend( this, CanvasBridgeMixin );

        /**
         * Prior to creation of the canvas, handle stuff on the page
         * to avoid potential race-condition with toggleDrawingMode when coming from a different mode/page --
         * same strategy as how now handling the canvas itself.
         * I suppose this could be done render but if we only we creating a canvas, placing here makes sense.
         * Note, unlike the canvas module, no action must be taken on the page view for an expanded note.
         */
        var activeNote = this.vChannel.request('activeNote');
        activeNote && this.triggerMethod( 'activeNoteChange', activeNote );

        this.createAndRenderCanvas(); // also puts in the channel ... that's not good; now also appends ...

    },

    /**
     * Hook forwarded from canvas mixin, called before event passed to the canvas.
     * Also now triggered on creation of canvas -- so if coming from different mode/page will not be skipped
     * from toggleEditMode from activeNote change ( like how where checking this on render of canvas now ).
     */
    onActiveNoteChange: function(note) {

        this.$el.toggleClass('canvas-edit-mode', note && note.isDrawable());

    },

    /**
     * For now canvas is still a separate layer.  The outer html el
     * Should be resized with the page but re-render the shapes.
     * Dream is later utilizing the css transform to be on the same plane as the Raphael canvas,
     * but that's a LARGE refactor.
     * Kept separate from scale for time-being.
     * Now, set a flag so update viewport doesn't touch the canvas (this must be done after).
     * Without, a scale would scale the canvas -- which we DON'T WANT --
     * It will break floating redaction, where if scale is called,
     * positions are not calculated correctly for code boxes ( think of it hacked in approach )
     * see controller.positionCodeViewsFromModelPts
     */
    rotate: function() {

        this.skipScalingCanvas = 1;

        PageImageWr.prototype.rotate.apply( this, arguments );

        delete this.skipScalingCanvas;

        // Now 'rotate' the canvas by redrawing the shapes ( the redraw takes rotation into account)
        if ( this.canvas ) {
            this.pgCanvasChannel.trigger('pageRotated');
        }

    },

    // Add's scaling the canvas -- ultimately we may want in basePage --
    // For now, leaves clearer what skipScalingCanvas means when called from rotation
    updateViewPort: function() {

        PageImageWr.prototype.updateViewPort.apply( this, arguments );

        if ( this.canvas && !this.skipScalingCanvas )
            this.canvas && this.scaleCanvas.apply(this, arguments);  //  trigger and optimize ..

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/pgMode/pagePgMode.js
 ** module id = 462
 ** module chunks = 0
 **/